/**
 * Extrae la ruta base de una URL (sin query ni fragment).
 */
export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

/**
 * Verifica si la ruta actual coincide con una URL dada (activo en menu).
 */
export function checkIsActive(pathname: string, url: string) {
  const current = getCurrentUrl(pathname)
  if (!current || !url) {
    return false
  }

  if (current === url) {
    return true
  }

  if (current.indexOf(url) > -1) {
    return true
  }

  return false
}
